import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import InviteApi from 'api/invite';

import SubmitButton from 'components/ui/buttons/SubmitButton';
import withModalView from 'components/ui/withModalView';
import withAuthorizer from 'components/ui/withAuthorizer';
import RoleSelect from 'components/users/RoleSelect';
import NotificationHelper from 'helpers/NotificationHelper';

import { useTranslation } from 'react-i18next';
import { Resources } from 'helpers/ResourceHelper';

const FormInvitePage = () => {
  const { t } = useTranslation();

  const [saving, setSaving] = useState(false);
  const [roles, setRoles] = useState([]);
  const history = useHistory();

  const onSubmit = async e => {
    e.preventDefault();

    const form_instance = new FormData(e.target);
    const form_entries = Object.fromEntries(form_instance);
    form_entries.roles = roles;

    try {
      setSaving(true);
      await InviteApi.create(form_entries);
      NotificationHelper.snack(t(`admin.invites.messages.invite_sent`));
      setTimeout(() => history.push('/admin'), 500);
    } catch (error) {
      if (error.response.status === 409) {
        NotificationHelper.snack(t(`admin.invites.messages.invite_conflit`));
      } else {
        NotificationHelper.snack(t(`messages.unexpected_error`));
      }
    } finally {
      setSaving(false);
    }
  };

  const onRolesChange = async roles => {
    const role_ids = roles.map(role => role.id);
    setRoles(role_ids);
  };

  return (
    <>
      <div className="container">
        <h1 className="m-0 p-0 fw-lighter">{t('admin.invites.title')}</h1>
      </div>

      <div className="container mt-4">
        <form onSubmit={onSubmit} style={{ width: 400 }}>
          <div className="form-group">
            <div>{t('admin.invites.form.email_input.label')}</div>
            <input
              type="email"
              disabled={saving}
              className="form-control"
              name="email"
              autoComplete="new-member"
              placeholder="email@domain.com"
              required
            />
          </div>

          <div className="form-group mt-3">
            <div>{t('admin.invites.form.role_input.label')}</div>
            <RoleSelect className="w-100" disabled={saving} onChange={onRolesChange} />
          </div>

          <div className="d-flex align-items-center mt-5">
            <SubmitButton tkey="actions.invite" loading={saving} className="me-2 btn btn-primary" />

            <Link disabled={saving} to={`/admin`} className="btn btn-light d-none d-lg-block">
              {t('actions.cancel')}
            </Link>
          </div>
        </form>
      </div>
    </>
  );
};

export default withModalView(withAuthorizer(FormInvitePage, [Resources.USER_MANAGER]));
